import { ADD_BROKER_MESSAGE_ERROR, ADD_BROKER_MESSAGE_SUCCESS, GET_BROKER_MESSAGE_FAIL, GET_BROKER_MESSAGE_SUCCESS } from "./actionTypes"

const initialState = {
  error: "",
  loading: false,
  messages: []
}

const Messages = (state = initialState, action) => {
  switch (action.type) {
    case ADD_BROKER_MESSAGE_SUCCESS:
      state = {
        ...state,
        loading: false,
      }
      break
    case ADD_BROKER_MESSAGE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_BROKER_MESSAGE_SUCCESS:
      return {
        ...state,
        messages: action.payload,
      }

    case GET_BROKER_MESSAGE_FAIL:
      return {
        ...state,
        error: action.payload,
      }
    default:
      state = { ...state }
      break
  }
  return state
}

export default Messages
